import payAttentionToEnergy from '@backrs_ui/grow-ui/src/assets/images/college-visit-guide/pro-tips/pay-attention-to-energy.png';
import talkToBusyStudents from '@backrs_ui/grow-ui/src/assets/images/college-visit-guide/pro-tips/talk-to-busy-students.png';
import trustYourGut from '@backrs_ui/grow-ui/src/assets/images/college-visit-guide/pro-tips/trust-your-gut.png';
import visitDifferentTypes from '@backrs_ui/grow-ui/src/assets/images/college-visit-guide/pro-tips/visit-different-types.png';
import visitInSession from '@backrs_ui/grow-ui/src/assets/images/college-visit-guide/pro-tips/visit-in-session.png';

/** Pro tip id → image asset. */
export const PRO_TIP_IMAGES: Readonly<Record<string, string>> = {
  'visit-different-types': visitDifferentTypes,
  'talk-to-busy-students': talkToBusyStudents,
  'visit-in-session': visitInSession,
  'trust-your-gut': trustYourGut,
  'pay-attention-to-energy': payAttentionToEnergy,
};
